import { useCallback, useContext } from 'react'

import { Label } from 'tools/Uniform'

import { PasswordContext, setPasswordMessage } from './reducer'

function EmailInput() {
  const [state, dispatch] = useContext(PasswordContext)

  const requestCode = useCallback((email, dispatch, request) => {
    if (email.length > 0 && email.includes('@')) {
      request(email, dispatch)
    } else {
      setPasswordMessage(dispatch, 'code', 'needEmail')
    }
  }, [])

  return (
    <>
      <Label>Password Reset</Label>
      <div className="mb3">
        Provide an email address you registered with. If it is in our system, we
        will send a reset request to that address.
      </div>
      <div className="flex-items-m gh3">
        <input
          className="w-100 w-50-l db"
          value={state.email.value}
          placeholder="Email Address"
          onChange={(ev) =>
            dispatch({ key: 'email', value: { value: ev.target.value.trim() } })
          }
        />
        <button
          className="button medium nowrap mt3 mt0-m"
          onClick={() =>
            requestCode(state.email.value, dispatch, state.requestReset)
          }
        >
          Request Reset Code
        </button>
      </div>
      {state.code.message && <div className="mt3 b"> {state.code.message}</div>}
    </>
  )
}

export default EmailInput
